import React, { useEffect, useState } from "react";
import { Shield, Trash2, XCircle } from "lucide-react";
import { toast } from "sonner";
import { TurfTalk } from "@/api/client";
import { PageHeader, Empty, Skeleton } from "@/components/ui-kit";

export default function ModerationPage() {
  const [reports, setReports] = useState(null);
  const [denied, setDenied] = useState(false);

  const load = () => TurfTalk.moderationReports()
    .then((r) => setReports(r.reports || []))
    .catch((e) => { if (String(e.message).toLowerCase().includes("moderator") || String(e.message).toLowerCase().includes("forbidden")) setDenied(true); setReports([]); });
  useEffect(() => { load(); }, []);

  const act = async (rep, action) => {
    try {
      await TurfTalk.moderationAction({ action, target_type: rep.target_type, target_id: rep.target_id, room_id: rep.room_id });
      toast.success(action === "dismiss" ? "Report dismissed" : "Action applied");
      load();
    } catch (e) { toast.error(e.message); }
  };

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8">
      <PageHeader title="Moderation" subtitle="Open reports for rooms you moderate. Only authorized context is shown; every action is audited." right={<Shield className="text-[#4ea152]" />} />
      {denied ? <Empty title="No moderator access" detail="You must own or moderate a room to see its report queue." icon={Shield} />
        : reports === null ? <div className="space-y-3">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-24" />)}</div>
        : reports.length === 0 ? <Empty title="Queue is clear" detail="No open reports right now." icon={Shield} />
        : (
          <div className="space-y-3">
            {reports.map((rep) => (
              <div key={rep.report_id || rep.id} className="tt-panel rounded-xl p-4" data-testid={`report-${rep.report_id || rep.id}`}>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-white/10 text-white/50 uppercase tracking-wide">{rep.target_type}</span>
                  <span className="text-white/40 text-xs">{rep.reason || rep.category || "reported"}</span>
                </div>
                {rep.context && <p className="text-white/60 text-sm italic mb-3">{rep.context}</p>}
                <div className="flex gap-2">
                  {rep.target_type === "message" && <button onClick={() => act(rep, "remove_message")} data-testid={`mod-remove-${rep.report_id || rep.id}`} className="inline-flex items-center gap-1.5 px-3 h-8 rounded-lg bg-[#D92D20]/15 text-[#ff6b60] text-xs"><Trash2 size={13} /> Remove message</button>}
                  <button onClick={() => act(rep, "dismiss")} data-testid={`mod-dismiss-${rep.report_id || rep.id}`} className="inline-flex items-center gap-1.5 px-3 h-8 rounded-lg tt-panel-3 text-white/80 text-xs"><XCircle size={13} /> Dismiss</button>
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}
